export const AdminDatasetAccessLevel = {
  OWNER: "owner",
  ANALYZE: "analyze",
  PREVIEW: "preview",
  NONE: "no access",
} as const;
export type AdminDatasetAccessLevel =
  (typeof AdminDatasetAccessLevel)[keyof typeof AdminDatasetAccessLevel];

export interface AdminDatasetSummary {
  id: string;
  title: string;
  description: string;
  accentColor: string;
  createdBy: string | null;
  updatedBy: string | null;
  created_at: string;
  updated_at: string;
  isDeleted: boolean;
  previewEnabled: boolean;
  cloudProviders: string[];
  slug?: string;
  access_level: AdminDatasetAccessLevel;
  actions_permitted: string[];
  is_preview: boolean;
  user_id: string | null;
}

export interface DatasetPageMetadata {
  limit: number;
  offset: number;
  total_count: number;
  has_more: boolean;
  sort?: string;
}

export interface AdminDatasetListResponse {
  items: AdminDatasetSummary[];
  metadata: DatasetPageMetadata;
}
